import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faPlus } from '@fortawesome/pro-duotone-svg-icons/faPlus'

import CreateContentDossier from '../../feature/ContentDossier/Create/CreateContentDossier.tsx'
import AppDialog from '@/Components/AppDialog/AppDialog'
import { CompactButton } from '@/Components/Elements/StyledComponents/Buttons'

class DossierModalNewButton extends Component {
    constructor(props) {
        super(props)

        this.state = {
            add: this.props.add === true,
            size: this.props.size ? this.props.size : 'small',
        }
    }

    renderAdd() {
        return (
            <AppDialog
                aria-labelledby="contained-modal-title-vcenter"
                open
                maxWidth={'lg'}
                fullWidth
                topAlign
                title={''}
                onClose={() => {
                    this.props.onClose ? this.props.onClose() : null
                    this.setState({ add: false })
                }}
                headerClose={() => {
                    this.props.onClose ? this.props.onClose() : null
                    this.setState({ add: false })
                }}
                contentProps={{ dividers: true }}
                key={`inline-modal-${this.props.dossierId}`}
            >
                <CreateContentDossier
                    kedo={this.props.kedo}
                    props={{
                        ...this.props,
                        location: this.props.location,
                        content: this.props.content,
                        onSuccess: (dossierId) => {
                            this.setState({ add: false })
                            this.props.onSuccess(dossierId)
                        },
                        onClose: () => {
                            this.setState({ add: false })
                            this.props.onClose()
                        },
                        defDossierId: this.props.defDossierId,
                        disableBreadcrumb: true,
                        size: this.state.size,
                    }}
                />
            </AppDialog>
        )
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.add !== this.state.add) {
            return true
        }

        return false
    }

    render() {
        if (!this.props.defDossierId) {
            return ''
        }

        if (
            this.props.kedo
                .env()
                .isAllowedDefDossier(
                    'create',
                    this.props.defDossierId,
                    this.props.kedo.user()
                ) !== true
        ) {
            return ''
        }

        return (
            <>
                {this.state.add === true ? this.renderAdd() : null}
                <CompactButton
                    dense={this.props.dense}
                    sx={{
                        display: 'inline-block',
                        ...(this.props.dense && {
                            width: '28px',
                            height: '28px',
                            minWidth: '28px',
                        }),
                    }}
                    className={'new-dossier-inline'}
                    onClick={() => this.setState({ add: true })}
                    size={this.state.size}
                >
                    <FontAwesomeIcon icon={faPlus} />
                </CompactButton>
            </>
        )
    }
}

export default DossierModalNewButton
